import React from 'react';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import type { ProductsSequence } from 'common/contracts';

import Button from 'components/Button/Button';

import MissionCard from '../Sections/MissionCard';
import type { TabsProps } from '../types';

const ConfigurationTab: React.FC<TabsProps> = ({
  formikProps,
  productsSequence,
  setProductsSequence
}) => {
  const { values, setFieldValue } = formikProps;

  const handleCreateNewProductSequence = () => {
    const newSeq = [
      ...values.productsSequence,
      {
        index: values.productsSequence.length + 1,
        priceInUsdCents: 0,
        products: [],
        barSize: 1
      }
    ];
    setFieldValue('productsSequence', newSeq);
  };

  return (
    <div className="w-[528px] mx-auto">
      {values.productsSequence.map(
        (productSequenceItem: ProductsSequence, sequenceIndex: number) => (
          <MissionCard
            key={productSequenceItem.index}
            formikProps={formikProps}
            productSequenceItem={productSequenceItem}
            sequenceIndex={sequenceIndex}
            productsSequence={productsSequence}
            setProductsSequence={setProductsSequence}
          />
        )
      )}
      <Button
        variant="secondary"
        onClick={handleCreateNewProductSequence}
        className="w-full"
        leftIcon={<AddCircleOutlineIcon />}
      >
        Add
      </Button>
    </div>
  );
};
export default ConfigurationTab;
